import { lazyLoad } from 'utils/loadable';

export const EditEnvironment = lazyLoad(
  () => import('./editEnvironment.page'),
  (module) => module.EditEnvironment
);
